export enum AlertClass {
    Error = 'c-alert-danger',
    Warning = 'c-alert-warning'
}

export interface Alert {
    alertClass: AlertClass;
    message: string;
}
